import './component.scss'

import './images/beginner.svg'
import './images/consultation_house.svg'
import './images/consultation_company.svg'
import './images/consultation_line.svg'
import './images/consultation_ai.svg'
import './images/consultation_all_quote.svg'


document.addEventListener('DOMContentLoaded', () => {
  document.getElementsByClassName('js-ChannelIO-openWorkflow').forEach(element => {
    element.addEventListener('click', () => {
      if (typeof window.ChannelIO === 'function') {
        window.ChannelIO('openWorkflow', element.dataset.channelId)
      } else {
        // ChannelIOが埋め込まれていない環境で正しく呼ばれていることを確認するためconsole.logを仕込む
        console.log(`call ChannelIO openWorkflow ${element.dataset.channelId}`)
      }
    })
  })
})
